import SwipperCard from "./SwipperCard";
import trophyICON from '../../assets/img/trophy.png'

const clockHistorySVG = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clock-history" viewBox="0 0 16 16">
    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z" />
    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z" />
    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z" />
</svg>;

const cancleSVG = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
</svg>;

const Projectmodal = ({ data, stateControl }) => {
    // state control inside
    // body blur
    // responsive
    return (
        <>
            <div >

                <div onClick={stateControl} className=" hidden z-40 bg-gray-700 opacity-50 fixed w-full h-screen sm:flex justify-center items-center ">
                </div>
                {/* modal content */}
                <div className="animation-opacity shadow-stripe z-50 fixed sm:w-auto w-full  bottom-15p  sm:h-auto h-screen bg-gray-50">
                    <div className="p-2 flex justify-end">
                        <div>

                            <button onClick={stateControl} className="text-black hover:text-red-600 stroke-w">{cancleSVG}</button>
                        </div>
                    </div>

                    <div className=" overflow-auto sm:flex sm:items-center pb-8 border border-b-2 border-gray-200 h-85p" >

                        {/* body */}
                        {/* <div className="px-4 pt-8 sm:grid sm:grid-cols-2 sm:h-auto sm:gap-8"> */}
                        <div className=" px-4 sm:pt-8 pt-2  sm:h-auto w-full">
                            {/* carousel */}

                            <div className="aspect-video w-full bg-img">
                                <SwipperCard images={{ cover: data.cover, hoverCover: data.hoverCover }} />
                            </div>

                            <div className="sm:h-full flex flex-col justify-between">
                                {/* text contents */}
                                <div>
                                    {/* project name */}
                                    <div>
                                        <h1 className="font-openSans font-semibold uppercase text-xl mt-4 mb-2">{data.title}</h1>
                                        
                                        { data.hackathon && 
                                        <div className="flex sm:mb-4 sm:mt-2 mt-3 mb-6 items-center ">
                                            <img src={trophyICON} className="h-4 mr-2" alt="" />
                                            <h1 className="font-openSans font-medium uppercase text-gray-500 font-6rem ">{data.hackathon}</h1>
                                        </div>}

                                    </div>

                                    {/* about */}
                                    {data.description &&
                                        <div className=" font-openSans  font-normal text-sm sm:mr-4">
                                            {data.description}
                                        </div>
                                    }
                                    {/* tags and time history */}
                                    <div className="mt-6  sm:mr-4  flex items-center font-notoSans uppercase  text-gray-700 font-6rem ">
                                        <h1>{data.tags}</h1>
                                        <div className="flex items-center ml-12">
                                            <span className="mr-1 scale-75">{clockHistorySVG} </span>
                                            <span className="">{data.startDate}</span>
                                        </div>
                                    </div>

                                </div>

                                {/* buttons */}
                                <div>
                                    <div className="mt-10 uppercase font-openSans font-semibold text-xs">
                                        <a href={data.github}  target={data.github == "#0" ? `_self` : '_blank'} className="hover:cursor-pointer py-0.5 px-3 bg-black text-white " >Github</a>
                                        {data.website && data.tags.toLowerCase().includes("game") ?
                                            <a href={data.website} target={data.website == "#0" ? `_self` : '_blank'} className="ml-2 py-0.5 px-3 bg-green-500 text-white hover:bg-green-600" >Play</a>
                                            :
                                            <a href={data.website} target={data.website == "#0" ? `_self` : '_blank'} className="hover:cursor-pointer ml-4 py-0.5 px-3 bg-sky-600 text-white hover:bg-sky-700" >website</a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* scroll down 15% space */}
                    <div className="mt-2 w-full sm:flex hidden sm:justify-end sm:items-center scale-90 text-gray-500">
                        <h1 className="font-openSans text-xs font-medium uppercase mr-4">Scroll down</h1>
                        <div className=" c-infinite"> <span class="c-link"> <span class="c-link__inner"> <span> <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.833 13.977l4.47-4.47 1.179 1.178L10 17.167l-6.482-6.482 1.179-1.178 4.47 4.47V3.833h1.666v10.144z" fill="currentColor"></path></svg> </span> <span class="c-link__animated"> <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.833 13.977l4.47-4.47 1.179 1.178L10 17.167l-6.482-6.482 1.179-1.178 4.47 4.47V3.833h1.666v10.144z" fill="currentColor"></path></svg> </span> </span> </span> </div>
                    </div>
                    <div className="mt-2 w-full  sm:hidden flex justify-end items-center scale-90 text-gray-500">
                        <div >{cancleSVG}</div>
                        <h1 className="font-openSans text-xs font-medium uppercase mr-2">Close</h1>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Projectmodal;